import React from 'react'

const Manual_invuPOS_pagos_automaticos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          InvuPOS - Pagos Automáticos
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía ofrece un proceso sencillo para agregar una nueva tarjeta de crédito en
          el panel administrativo de Invu, cubriendo datos de la tarjeta y direcciones de facturación,
          para optimizar la gestión de pagos y evitar errores al introducir datos.
        </p>
        <iframe
          src="https://scribehow.com/embed/InvuPOS__Pagos_Automaticos__3IcE5S78TlqnQ2no8WjdrQ?as=scrollable"
          className="scribe-iframe-general-11"
          width="100%"
          height="4900"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_invuPOS_pagos_automaticos